/**
 * A public customer cannot self-modify a reservation whose party size exceeds
 * the online maximum (typically groups created by staff). Same condition as
 * update-reservation-public: only `number_of_people` is compared to max_people.
 */
export function isGroupAboveOnlineLimit(
  numberOfPeople: number | null | undefined,
  maxPeople: number | null | undefined,
): boolean {
  return (numberOfPeople || 0) > (maxPeople ?? 20);
}

export const GROUP_MODIFICATION_MESSAGE =
  "Votre réservation de groupe a été prise par le restaurant. Pour la modifier, merci de contacter directement l'établissement.";

export interface GroupContactSettings {
  largeGroupEmailEnabled?: boolean;
  largeGroupContactMethod?: 'email' | 'phone' | string | null;
  largeGroupEmail?: string | null;
  largeGroupPhone?: string | null;
}

/**
 * Large-group contact enabled -> only the chosen method (email OR phone).
 * Otherwise -> establishment phone and email.
 */
export function resolveGroupContact(
  settings: GroupContactSettings | null | undefined,
  establishment: { phone?: string | null; email?: string | null } | null | undefined,
): { phone: string | null; email: string | null } {
  if (settings?.largeGroupEmailEnabled) {
    if (settings.largeGroupContactMethod === 'phone' && settings.largeGroupPhone) {
      return { phone: settings.largeGroupPhone, email: null };
    }
    if (settings.largeGroupContactMethod !== 'phone' && settings.largeGroupEmail) {
      return { phone: null, email: settings.largeGroupEmail };
    }
  }
  return { phone: establishment?.phone || null, email: establishment?.email || null };
}
